import React, { useEffect, useState } from 'react';
import apiFetcher from '../../utils/apiFetcher';

export const ContactForm = () => {
  const [services, setServices] = useState([]);
  const [status, setStatus] = useState(''); // '' | 'sending' | 'success' | 'error'

  const WEB3FORMS_KEY = "25aa00f0-56a8-48ec-bdb1-48c039ff571c";

  // Pobieranie usług
  const getServices = async () => {
    try {
      const res = await apiFetcher.getServices('Kolesin (wieś)');
      setServices(res.service || []);
    } catch (error) {
      console.error("Błąd pobierania usług:", error);
    }
  };

  useEffect(() => {
    getServices();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error(error);
      setStatus('error');
    }
  };

  return (
    <div className="contact-form-section">
      <div className="contact-form-container">
        <h2>Skontaktuj się z nami</h2>

        {status === 'success' && (
          <div className="form-success-message">
            ✅ <strong>Dziękujemy!</strong> Twoja wiadomość została wysłana pomyślnie.<br />
            Odezwiemy się najszybciej jak to możliwe.
          </div>
        )}

        {status === 'error' && (
          <div className="form-error">
            ❌ Coś poszło nie tak. Spróbuj ponownie za chwilę.
          </div>
        )}

        <form onSubmit={handleSubmit}>
          
          {/* Klucz Web3Forms */}
          <input type="hidden" name="access_key" value={WEB3FORMS_KEY} />

          {/* Opcjonalne - temat wiadomości w skrzynce */}
          <input type="hidden" name="subject" value="" />

          {/* Honeypot */}
          <p hidden>
            <label>
              Nie wypełniaj tego: <input name="bot-field" />
            </label>
          </p>

          <div className="form-grid">
            <div className="form-group">
              <label>Imię i nazwisko</label>
              <input 
                type="text" 
                name="name" 
                required 
                placeholder="Jan Kowalski" 
              />
            </div>

            <div className="form-group">
              <label>Telefon</label>
              <input 
                type="tel" 
                name="phone" 
                required 
                placeholder="123 456 789" 
              />
            </div>

            <div className="form-group full-width">
              <label>Email</label>
              <input 
                type="email" 
                name="email" 
                required 
                placeholder="twoj@email.pl" 
              />
            </div>

            <div className="form-group full-width">
              <label>Temat</label>
              <select name="subject" required>
                <option value="">Wybierz temat</option>
                <option value="zapytanie-o-cene">Zapytanie o cenę</option>
                <option value="zamowienie">Chcę złożyć zamówienie</option>
                
                {services.map((service, i) => (
                  <option key={i} value={`Zapytanie o produkt: ${service}`}>
                    Zapytanie o: {service}
                  </option>
                ))}

                <option value="inne">Inne pytanie</option>
              </select>
            </div>

            <div className="form-group full-width">
              <label>Wiadomość</label>
              <textarea 
                name="message" 
                rows="7" 
                required 
                placeholder="Napisz tutaj swoją wiadomość lub pytania..."
              />
            </div>
          </div>

          <button 
            type="submit" 
            id="adress-submit-button"
            disabled={status === 'sending'}
          >
            {status === 'sending' ? 'Wysyłam...' : 'Wyślij wiadomość'}
          </button>
        </form>
      </div>
    </div>
  );
};

